<template>
    <dash
        icon="fa fa-cubes"
        titulo="PLEITOS"
        @click.native="$router.push(rota)"
        :qtd="qtd"
        :mostrarQtd="false"
        :loading="loading"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    props: {
        rota: {
            type: Object,
            default: () => ({
                name: 'Pleitos'
            })
        },

        qtd: {
            type: Number
        },

        loading: {
            type: Boolean
        }
    },

    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
